import { useState } from 'react';
import { rankingTabs } from '@/mocks/movies';

export default function RankingsTabs() {
  const [activeKey, setActiveKey] = useState(rankingTabs[0].key);
  const active = rankingTabs.find((t) => t.key === activeKey) ?? rankingTabs[0];

  return (
    <section id="rank" className="w-full bg-foreground-950 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div className="max-w-2xl">
              <span className="text-xs md:text-sm font-medium text-primary-400 tracking-widest">RANKINGS</span>
              <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-background-50">
                多维度榜单：换个角度看同一批电影
              </h2>
              <p className="mt-3 text-sm md:text-base text-background-200/80 leading-relaxed">
                同一部影片，在评分、热度与口碑上可能表现不同。切换榜单标签，找到最贴合你当下需求的排序方式。
              </p>
            </div>

            <div
              className="flex items-center gap-1 p-1 rounded-full bg-background-50/10 w-max shrink-0"
              role="tablist"
              aria-label="榜单切换"
            >
              {rankingTabs.map((tab) => {
                const isActive = tab.key === activeKey;
                return (
                  <button
                    key={tab.key}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    onClick={() => setActiveKey(tab.key)}
                    className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                      isActive ? 'bg-primary-500 text-background-50' : 'text-background-200 hover:bg-background-50/10'
                    }`}
                  >
                    {tab.label}
                  </button>
                );
              })}
            </div>
          </div>

          <p className="mt-6 text-xs md:text-sm text-background-200/70">{active.hint}</p>

          <ol className="mt-4 grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-1">
            {active.items.map((item, idx) => (
              <li
                key={item.id}
                className="flex items-center gap-4 border-b border-background-50/10 py-3.5"
              >
                <span
                  className={`shrink-0 w-9 text-center font-heading font-bold text-lg ${
                    idx < 3 ? 'text-accent-400' : 'text-background-50/40'
                  }`}
                >
                  {idx + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-medium text-sm md:text-base text-background-50 truncate">{item.title}</h3>
                    <span className="shrink-0 text-xs text-background-200/60">{item.year}</span>
                  </div>
                  <p className="mt-0.5 text-xs text-background-200/60 truncate">
                    {item.region} · {item.note}
                  </p>
                </div>
                <span className="shrink-0 font-heading font-bold text-lg md:text-xl text-primary-400">
                  {item.value}
                </span>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}